import { render, staticRenderFns } from "./FindDuplicatedPatients.vue?vue&type=template&id=78da90af&"
import script from "./FindDuplicatedPatients.vue?vue&type=script&lang=js&"
export * from "./FindDuplicatedPatients.vue?vue&type=script&lang=js&"
import style0 from "./FindDuplicatedPatients.vue?vue&type=style&index=0&id=78da90af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports